import React, { useMemo } from 'react';
import styles from "../../styles.module.scss";
import { DataRow } from './StudentDetails';

const labelAndFieldMapping = [
    { label: "Course ID", field: "courseIds" },
    { label: "Term", field: "terms" },
]

const CourseDetails = ({ selectedCharges }) => {

    const courseAndTermDetails = useMemo(() => {

        const distinctCourseIds = new Set();
        const distinctTerms = new Set();

        for (let charge of selectedCharges['REGULAR_CHARGES']) {
            distinctCourseIds.add(`${charge?.courseId}`);
            distinctTerms.add(`${charge?.term}`);
        }

        for (let charge of selectedCharges['OTHER_CHARGES']) {
            distinctCourseIds.add(`${charge?.courseId}`);
            distinctTerms.add(`${charge?.term}`);
        }

        return {
            courseIds: [...distinctCourseIds]?.join(","),
            terms: [...distinctTerms]?.join(",")
        }

    }, [selectedCharges])

    return (
        <>
            <div className={`mb-2 ${styles['review-details-row-value']}`}>Course Details</div>

            {labelAndFieldMapping?.map(el =>
                <DataRow key={el?.label} label={el?.label} value={courseAndTermDetails?.[el?.field]} />
            )}

            <hr className='my-3' />
        </>
    );
}

export default CourseDetails;